import { FilterIcon } from '@pmi/dsm-react/dist/components/icons/16';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import { Button } from 'react-bootstrap';
import styles from './filterByBlock.module.scss';

export interface FilterByButtonProps {
  onClick: () => void;
  open: boolean;
}
export default function FilterByButton({
  onClick,
  open = false,
}: FilterByButtonProps) {
  return (
    <Button onClick={onClick} className={styles.filterButton} variant="link">
      <FilterIcon fontSize="sm" className="me-1" />
      Filters
      {open && <ChevronUpIcon className="ms-1" fontSize="sm" />}
      {!open && <ChevronDownIcon className="ms-1" fontSize="sm" />}
    </Button>
  );
}
